import React, { useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { VscAccount } from "react-icons/vsc";
import { MdAccountBalanceWallet } from "react-icons/md";
import WalletSidebar from "./WalletSidebar";
import Login from "./Login";
import Home from "./Home";
// import "./index.css";
import "./Navbar.css";
import Greet from '../components/Greet';

function Nav(props) {
  console.log("Propsnav",props.nfts)
  const loggedIn = sessionStorage.getItem("LoggedIn");
  const [sidebar, setSidebar] = useState(false);
  const [searchInput, setSearchInput] = useState("");

  const showSidebar = () => setSidebar(!sidebar);

  // Live search — fires on every keystroke
  const handleSearchChange = (e) => {
    const val = e.target.value;
    setSearchInput(val);
    if (props.onSearch) props.onSearch(val);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (props.onSearch) props.onSearch(searchInput);
  };
    return (
        <nav className="navbar navbar-expand-lg navbar-light text-light color">
            <div className="container-fluid text-light" >
            {/* <img src="https://snapperfuturetech.com/wp-content/uploads/2020/06/cropped-Snapper-Futuretech-Final-logo_png-TRANSPARENT-Big-Size-2-175x61.png" alt="snapper-logo"></img> */}
                <Link className="navbar-brand fs-2 ms-4" to="/">
                <img style={{'height':'40px'}} src="https://tracechaintemplates.s3.ap-south-1.amazonaws.com/WhiteFont_Logo.png"></img>
                    {/* <img src="https://snapperfuturetech.com/wp-content/uploads/2020/06/cropped-Snapper-Futuretech-Final-logo_png-TRANSPARENT-Big-Size-2-175x61.png" alt="snapper-logo"></img> */}
                </Link>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                &nbsp;&nbsp;
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    {/* <ul className="navbar-nav me-auto mb-2 mb-lg-0"> */}
                    <ul className="navbar-nav mb-2 mb-lg-0">
                        <li className="nav-item" color="#fff">
                            {/* <a className="nav-link active fs-4" aria-current="page" href="/home" 
                            style={{color : "#fff"}}>Market-Place</a> */}
                            <a className="nav-link active" aria-current="page" href="/home" style={{ color: "#fff", fontSize: "19px" }}>
        Market-Place
    </a>
                        </li>
                        {/* <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                Dropdown
                            </a>
                            <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                <li><a className="dropdown-item" href="#">Action</a></li>
                                <li><a className="dropdown-item" href="#">Another action</a></li>
                                <li><hr className="dropdown-divider"/></li>
                                <li><a className="dropdown-item" href="#">Something else here</a></li>
                            </ul>
                        </li> */}

                    </ul>
                    {props.showSearch ? (
                    <form className="d-flex mx-auto navbar-search-form" onSubmit={handleSearchSubmit}>
                        <input
                          className="navbar-search-input"
                          type="search"
                          placeholder="Search by Name, Supplier, Price, ID, Platform…"
                          aria-label="Search"
                          value={searchInput}
                          onChange={handleSearchChange}
                        />
                    </form>
                    ) : (
                    <div className="mx-auto" />
                    )}
                    &nbsp;
                    <div style={{marginTop: "5px", marginBottom: "5px"}}>
                    {
                    loggedIn ?
                    (<Greet></Greet>) : null
                    }
                    </div>
                    {/* <ul className="navbar-nav mb-2 mb-lg-0">
                        <li className="nav-item list-spacing">
                            <a className="nav-link active" aria-current="page" href="/register"><VscAccount style={{ fontSize: '28px' }} /></a>
                        </li>
                        <li className="nav-item list-spacing">
                            <a className="nav-link active" aria-current="page" href="/connection"><MdAccountBalanceWallet style={{ fontSize: '28px' }} /></a>
                        </li>
                        {/* <li className="nav-item list-spacing">
                            <a className="nav-link active" aria-current="page" href="#"><GrCart style={{ fontSize: '28px' }} /></a>
                        </li> 
                    </ul> */}
                    
                    <div className="navbar-nav mb-2 mb-lg-0">
                        <div className="nav-item list-spacing menu">
                            <a className="menu-button nav-link active profileiconcolor" aria-current="page" style={{ fontWeight: 'bold' }} ><VscAccount style={{ fontSize: '30px'}} /></a>
                            <div className="dropdown-menu">
                                {loggedIn ? (
                                    <>
                                        <a href="/profile">My Profile</a>
                                        <a href="/Mynfts">My NFTs</a>
                                        <a href="/OffsetCredits">Offset Credits</a>
                                        <a href="/logout">Log Out</a>
                                    </>
                                ) : (
                                    <>
                                        <a href="/login">Login</a>
                                        <a href="/register">Register</a>
                                    </>
                                )}
                            </div>
                        </div>
                        {/* <div className="nav-item list-spacing">
                            <button className="menu-button nav-link active walletcolor" aria-current="page" onClick={showSidebar}><MdAccountBalanceWallet style={{ fontSize: '28px' }} /></button>
                        </div> */}
                        <nav className={sidebar ? 'nav-menu active' : 'nav-menu'}>
                            <ul className='nav-menu-items' onClick={showSidebar}>
                                <li className='navbar-toggle'>
                                    {/* <Link to='#' className='menu-bars'>
                                        <AiIcons.AiOutlineClose />
                                    </Link> */}
                </li>
                <WalletSidebar />
              </ul>
            </nav>
            {/* <li className="nav-item list-spacing">
                            <a className="nav-link active" aria-current="page" href="#"><GrCart style={{ fontSize: '28px' }} /></a>
                        </li> */}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Nav;
